module.exports = __webpack_public_path__ + "img/pd-img50.85e9cbc9.jpg";